<template>
    <div class="dizhi">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
        </van-nav-bar>
        <van-address-edit
                :area-list="areaList"
                show-postal
                show-set-default
                show-search-result
                :search-result="searchResult"
                :address-info="addressInfo"
                @save="onSave"
        />
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";

    export default {
        data() {
            return {
                title: '添加地址',
                token: '',
                adsId: '',
                areaList: {},
                searchResult: [],
                addressInfo: {},
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            await this.getFwSqus()
        },
        methods: {
            onSave(content) {
                this.saveFwAddress(content)
            },
            async saveFwAddress(content) {
                content.token = this.token
                if (this.adsId) {
                    content.id = this.adsId
                }
                let res = await this.$post("/fw/saveFwAddress", content)
                if (res.code == 200) {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: '#1989fa'
                    });
                    this.onClickLeft()
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },


            async getFwSqus() {
                let res = await this.$get("/fw/getFwSqus")
                this.areaList = res.areaList
            },

            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            }
        },
    };
</script>

<style lang="scss" scoped>

    .dizhi {
        padding-top: 50px;
        padding-bottom: 50px;
        overflow: scroll;
    }

    ::v-deep .van-nav-bar__title {
        max-width: 60%;
        margin: 0 auto;
        color: #323233;
        font-weight: 500;
        font-size: 15px;
    }


</style>
